import PlyWidget from './WidgetForm.vue';

export default PlyWidget;
